import { SET_TEMPLATES_TO_STORE } from "./reducers";
import { AlternativeTemplate, Template } from "app/types/model-types";

import { Action } from "app/types/app-types"
import { isDifferentTemplateform } from "shape-edit/forms/helpers";

export const MAX_BUFFER_SIZE = 9

export type TemplateOrAlternativeTemplateType = (Template | AlternativeTemplate)
export type UndoRedoHistory = {
    initial: TemplateOrAlternativeTemplateType
    buffer: TemplateOrAlternativeTemplateType[]
    index: number
}

const initHistory: UndoRedoHistory = {
    initial: null,
    buffer: [],
    index: -1,
}

export const PUSH_PRESENT_HISTORY = 'PUSH_PRESENT_HISTORY'

export function undoRedoHistoryReducer(undoRedoHistory: UndoRedoHistory = initHistory, action: Action<UndoRedoHistory>): UndoRedoHistory {
    switch (action.type) {
        case REDO_HISTORY:
            return { ...undoRedoHistory, index: nextIndex(undoRedoHistory.index) }
        case UNDO_HISTORY:
            return { ...undoRedoHistory, index: prevIndex(undoRedoHistory.index) }
        case PUSH_PRESENT_HISTORY:
            return { ...action.payload }
        case CLEAR_HISTORY:
        case SET_TEMPLATES_TO_STORE:
            return { ...initHistory }
        default:
            return undoRedoHistory
    }
}


// Undo/Redo history actions :
export const UNDO_HISTORY = 'UNDO_HISTORY'
export function undoHistory() {
    return {
        type: UNDO_HISTORY,
    }
}

export const REDO_HISTORY = 'REDO_HISTORY'
export function redoHistory() {
    return {
        type: REDO_HISTORY,
    }
}

export const CLEAR_HISTORY = 'CLEAR_HISTORY'
export function clearHistory(form?: TemplateOrAlternativeTemplateType) {
    return {
        type: CLEAR_HISTORY,
        payload: form || null
    }
}

export function nextIndex(index: number): number {
    return (index + 1) % MAX_BUFFER_SIZE
}

export function prevIndex(index: number): number {
    return (MAX_BUFFER_SIZE + index - 1) % MAX_BUFFER_SIZE
}